// 0 = passed, 1 = in-progress (attempts > 0 but never passed), 2 = never started
export const completionTier = (row) => {
  if (row.ever_passed) return 0;
  if (row.attempts > 0) return 1;
  return 2;
};

const nameKey = (row) =>
  (row.full_name || row.username || row.title || '').toLowerCase();

export const sortByCompletion = (rows) =>
  [...rows].sort((a, b) => {
    const t = completionTier(a) - completionTier(b);
    if (t !== 0) return t;
    return nameKey(a).localeCompare(nameKey(b));
  });
